import { getCountryCallingCode, getExampleNumber, CountryCode, isValidPhoneNumber } from 'libphonenumber-js'
import countries from 'i18n-iso-countries';
import examples from 'libphonenumber-js/mobile/examples';

export interface CountryInfo {
    code: string;
    name: string;
    dialCode: string;
    flag: string;
    pattern: RegExp;
    placeholder: string;
    format: string;
}

function phoneMask(value: string) {
    return value.replace(/\d/g, '#')
}

function phonePattern(value: string, code: string) {
    const digits = value.substring(code.length + 1).replace(/\D/g, '');

    return new RegExp(`^\\+${code}\\d{${digits.length}}$`);
}

const countryToFlag = (countryCode: string) => {
    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char => 0x1F1E6 + char.charCodeAt(0) - 'A'.charCodeAt(0));

    return String.fromCodePoint(...codePoints);
};

export const getCountryInfo = (countryCode: string): CountryInfo | null => {
    try {
        const code = countryCode as CountryCode;
        const countryName = countries.getName(code, 'en') || '';
        const dialCode = getCountryCallingCode(code);
        const example = getExampleNumber(code, examples);
        const placeholder = (example?.formatNational() || '');
        const pattern = phonePattern(example?.formatInternational() || '', dialCode);
        const format = phoneMask(example?.formatNational() || '');
    
        return {
            code,
            name: countryName,
            dialCode: `+${dialCode}`,
            flag: countryToFlag(code),
            // simple validation pattern
            pattern: pattern,
            // example local placeholder
            placeholder: placeholder,
            // example international format
            format: format,
        }
    } catch (error: any) {
        // console.dev("getCountryInfo", countryCode);
        // console.dev("getCountryInfo", error.message);
    }

    return null;
}

